import { createSelector } from 'reselect'
import { State } from 'index'

const storeSelector = (state: State) => state.store

export const getOpenTime = createSelector([storeSelector], (state) => state.business_hours)
export const getHolidays = createSelector([storeSelector], (state) => state.holidays)
export const getIsBeforePublishingStock = createSelector([storeSelector], (state) => state.is_before_publishing_stock)
export const getLastOrderTime = createSelector([storeSelector], (state) => state.last_order_time)
export const getLastPickupTime = createSelector([storeSelector], (state) => state.last_pickup_time)
// export const getOpenTime = createSelector([storeSelector], (state) => state.open_time)
export const getOrderStartTime = createSelector([storeSelector], (state) => state.order_start_time)
export const getRelativePickupableTime = createSelector([storeSelector], (state) => state.relative_pickupable_time)
export const getShopRef = createSelector([storeSelector], (state) => state.shop_ref)
export const getStoreId = createSelector([storeSelector], (state) => state.store_id)
export const getStoreName = createSelector([storeSelector], (state) => state.name)
export const getStoreStatus = createSelector([storeSelector], (state) => state.status)
export const getStores = createSelector([storeSelector], (state) => state.stores)
export const getShoppingBags = createSelector([storeSelector], (state) => state.shopping_bags)
export const getStoreCreatedAt = createSelector([storeSelector], (state) => state.created_at)
